import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Page from './Page';
import DynamicBackgroundContainer from '../components/DynamicBackgroundContainer';
import { dynamicFontSize, fontFamilyHeading } from '../styles/helpers/mixins';
import { Container } from '../styles/Container';
import { color, size } from '../styles/helpers/variables';
import connect from '../store/connect';
import { fetchArticlePageView } from '../actions/actionCreators';
import { Heading } from '../styles/Heading';
import { Preamble } from '../styles/Preamble';
import { HtmlWrapper } from '../styles/HtmlWrapper';
import BlockquoteWithImages from '../components/BlockquoteWithImages';
import SideMenu from '../components/SideMenu';
import ReadMoreAbout from '../components/ReadMoreAbout';
import ArticleImageBlock from '../components/ArticleImageBlock';
import { SITE_ROOT_URL } from '../constants/endpoints';
import { LoadingHeading, LoadingPreamble, LoadingBody } from '../styles/LoadingState';
import ErrorPage from './ErrorPage';
import NotFoundPage from './NotFoundPage';
import { isIE } from '../util/isIE';
import { Conditional } from '../components/Conditional';

class ArticlePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentBackgroundColor: null
    };
    this.componentScrollHandler = this.componentScrollHandler.bind(this);
  }

  componentWillMount() {
    window.addEventListener('scroll', this.componentScrollHandler);
    if (
      this.props.location.pathname.includes(String(document.getElementById('react_root').dataset.litiumPreview)) &&
      document.getElementById('react_root').dataset.litiumPreviewId
    ) {
      this.props.fetchArticlePageView({
        id: document.getElementById('react_root').dataset.litiumPreviewId,
        url: document.getElementById('react_root').dataset.litiumPreview,
        workingCopy: document
          .getElementById('react_root')
          .dataset.litiumPreview.toString()
          .includes(this.props.location.pathname)
      });
    } else {
      this.props.fetchArticlePageView({ urlPath: this.props.location.pathname });
    }
  }

  componentDidUpdate(prevProps) {
    // call action fetchArticlePageView if component updated with a new this.props.location.pathname
    if (!prevProps.location.pathname || this.props.location.pathname !== prevProps.location.pathname) {
      if (
        this.props.location.pathname.includes(String(document.getElementById('react_root').dataset.litiumPreview)) &&
        document.getElementById('react_root').dataset.litiumPreviewId
      ) {
        this.props.fetchArticlePageView({
          id: document.getElementById('react_root').dataset.litiumPreviewId,
          url: document.getElementById('react_root').dataset.litiumPreview,
          workingCopy: document
            .getElementById('react_root')
            .dataset.litiumPreview.toString()
            .includes(this.props.location.pathname)
        });
      } else {
        this.props.fetchArticlePageView({ urlPath: this.props.location.pathname });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.componentScrollHandler);
  }

  componentScrollHandler() {
    const { currentPage } = this.props;
    const currentPageFields = currentPage.get('fields', Map());

    // if quoteSection top and bottom is between the page center, change the background color of the page
    if (
      this.quoteSection &&
      this.quoteSection.getBoundingClientRect().top < window.innerHeight / 2 &&
        this.quoteSection.getBoundingClientRect().bottom >= window.innerHeight / 2
    ) {
      this.setState({ currentBackgroundColor: currentPageFields.get('imageQuoteColor') });
    } else if (
      this.imageSection &&
      this.imageSection.getBoundingClientRect().top < window.innerHeight / 2 &&
      this.imageSection.getBoundingClientRect().bottom >= window.innerHeight / 2
    ) {
      // else if imageSection top and bottom is between the page center, change the background color of the page
      this.setState({ currentBackgroundColor: currentPageFields.get('imageSectionColor') });
    } else if (
      this.employeeSection &&
      this.employeeSection.getBoundingClientRect().top < window.innerHeight / 2 &&
      this.employeeSection.getBoundingClientRect().bottom >= window.innerHeight / 2
    ) {
      // else if employeeSection top and bottom is between the page center, change the background color of the page
      this.setState({ currentBackgroundColor: currentPageFields.get('backgroundColor') });
    } else {
      // else set the background color to default
      this.setState({
        currentBackgroundColor: null
      });
    }
  }

  render() {
    const { currentPage, request } = this.props;

    if (request.get('statusCode') === 404) return <NotFoundPage />;
    if (request.get('status') === 'ERROR') return <ErrorPage />;

    const currentPageFields = currentPage.get('fields', Map());
    const employees = currentPage.get('children', List());
    const topBody = () => ({ __html: currentPageFields.get('text1') || currentPageFields.get('text') });
    const bottomBody = () => ({ __html: currentPageFields.get('text2') });

    if (request.get('status') === 'LOADING') {
      return (
        <Page meta={currentPage.get('metaData')} bgColor={color.white} loadingState>
          <TopArticleContainer>
            <MainContent>
              <LoadingHeading />
              <LoadingPreamble />
              <LoadingBody />
            </MainContent>
            <SideMenu />
          </TopArticleContainer>
        </Page>
      );
    }
    return (
      <DynamicBackgroundContainer
        staticColor={color.white}
        dynamicColor={this.state.currentBackgroundColor}
        active={!!this.state.currentBackgroundColor}
      >
        <Page meta={currentPage.get('metaData')}>
          <TopArticleContainer>
            <MainContent>
              <ArticleHeader textAlign={this.props.pageWidth >= size.large ? 'left' : 'center'}>
                {currentPageFields.get('title')}
              </ArticleHeader>
              <ArticlePreamble textAlign={this.props.pageWidth >= size.large ? 'left' : 'center'}>
                {currentPageFields.get('introduction') || currentPageFields.get('preamble')}
              </ArticlePreamble>
              <HtmlWrapper dangerouslySetInnerHTML={topBody()} />
            </MainContent>
            <SideMenu />
          </TopArticleContainer>

          {currentPageFields.get('imageQuoteText') ? (
            <div
              ref={ref => {
                this.quoteSection = ref;
              }}
            >
              <BlockquoteWithImages
                leftImage={SITE_ROOT_URL + currentPageFields.getIn(['imageQuoteLeftImage', 'url'])}
                rightImage={SITE_ROOT_URL + currentPageFields.getIn(['imageQuoteRightImage', 'url'])}
                quote={currentPageFields.get('imageQuoteText')}
                paddedBottom
              />
            </div>
          ) : (
            false
          )}

          {currentPageFields.get('text2') ? (
            <TopArticleContainer>
              <HtmlWrapper dangerouslySetInnerHTML={bottomBody()} />
            </TopArticleContainer>
          ) : (
            false
          )}

          {currentPageFields.getIn(['imageSectionLeftImage', 'url']) ||
          currentPageFields.getIn(['imageSectionRightImage', 'url']) ? (
            <div
              ref={ref => {
                this.imageSection = ref;
              }}
            >
              <ArticleImageBlock
                leftImage={SITE_ROOT_URL + currentPageFields.getIn(['imageSectionLeftImage', 'url'])}
                rightImage={SITE_ROOT_URL + currentPageFields.getIn(['imageSectionRightImage', 'url'])}
              />
            </div>
          ) : (
            false
          )}

          {!employees.isEmpty() ? (
            <div
              ref={ref => {
                this.employeeSection = ref;
              }}
            >
              <TopArticleContainer>
                <EmployeeHeading>{currentPageFields.get('subTitle')}</EmployeeHeading>
              </TopArticleContainer>
              <Container>
                <EmployeesList>
                  {employees.map(employee => (
                    <EmployeeListItem key={employee.get('id')}>
                      <EmployeeImage>
                        {isIE ? (
                          <EmployeeImageBackground
                            imageUrl={SITE_ROOT_URL + employee.getIn(['fields', 'image', 'url'])}
                          />
                        ) : (
                          <img
                            src={SITE_ROOT_URL + employee.getIn(['fields', 'image', 'url'])}
                            alt={employee.getIn(['fields', 'image', 'alt'])}
                          />
                        )}
                      </EmployeeImage>
                      <EmployeeName>{employee.getIn(['fields', 'name'])}</EmployeeName>
                      <Conditional show={!!employee.getIn(['fields', 'productLink'])}>
                        <EmployeeLink to={employee.getIn(['fields', 'productLink'])}>
                          {employee.getIn(['fields', 'productLinkText'])}
                        </EmployeeLink>
                      </Conditional>
                    </EmployeeListItem>
                  ))}
                </EmployeesList>
              </Container>
            </div>
          ) : (
            false
          )}

          {currentPageFields.getIn(['readMoreLink1', 'name']) && currentPageFields.getIn(['readMoreLink1', 'name']) ? (
            <Container>
              <ReadMoreContainer>
                <ReadMoreAbout
                  pos="left"
                  pageTitle={currentPageFields.getIn(['readMoreLink1', 'name'])}
                  pageUrl={currentPageFields.getIn(['readMoreLink1', 'url'])}
                />
                <ReadMoreAbout
                  pos="right"
                  pageTitle={currentPageFields.getIn(['readMoreLink2', 'name'])}
                  pageUrl={currentPageFields.getIn(['readMoreLink2', 'url'])}
                />
              </ReadMoreContainer>
            </Container>
          ) : (
            false
          )}
        </Page>
      </DynamicBackgroundContainer>
    );
  }
}

const EmployeeHeading = styled.h3`
  ${fontFamilyHeading};
  ${dynamicFontSize(26, 32)};
  font-weight: normal;
  line-height: 1.25;
  position: relative;
  padding-bottom: 37px;
  margin: 0;

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 147px;
    bottom: 0;
    left: 0;
    height: 1px;
    background: #979797;
  }

  @media screen and (min-width: ${size.large}px) {
    margin-top: 30px;
    margin-bottom: 16px;
  }
`;

const EmployeeLink = styled(Link)`
  width: max-content;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #6a6a6a;
  text-transform: uppercase;
  text-decoration: none;
  position: relative;
  &:after,
  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 6px;
    height: 1px;
    background: #6a6a6a;
    right: -10px;
  }
  &:after {
    transform: rotate(40deg);
    top: calc(50% - 2px);
  }
  &:before {
    top: calc(50% + 2px);
    transform: rotate(-40deg);
  }
`;

const EmployeeName = styled.p`
  ${fontFamilyHeading};
  font-size: 20px;
  line-height: 0.8;
  margin: 0 0 11px;
`;

const EmployeeImage = styled.div`
  width: 100%;
  padding-bottom: 100%;
  position: relative;
  margin-bottom: 15px;
  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const EmployeeImageBackground = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url("${props => props.imageUrl}");
  background-size: cover;
  background-position-x: center;
  background-position-y: center;
`;

const EmployeeListItem = styled.li`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 0 40px;

  @media screen and (min-width: ${size.medium}px) {
    width: calc(100% / 2 - 24px);
    &:nth-child(3) {
      width: 100%;
      margin: 0 0 50px;
      ${EmployeeImage} {
        padding-bottom: calc((268 / 559) * 100%);
      }
    }
  }

  @media screen and (min-width: ${size.xXLarge}px) {
    margin: 0 14px 50px;
    width: calc(100% / 4 - 28px);
    &:nth-child(3) {
      width: calc(100% / 2 - 28px);
      margin: 0 14px 50px;
      ${EmployeeImage} {
        padding-bottom: calc((268 / 559) * 100%);
      }
    }
  }
`;

const EmployeesList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  width: auto;

  &::after {
    content: '';
    flex: auto;
  }

  @media screen and (min-width: ${size.medium}px) {
    padding: 0 0 60px;
    margin: 0 -14px;
  }
`;

const MainContent = styled.div`
  width: 100%;
`;

const ReadMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media screen and (min-width: ${size.medium}px) {
    align-items: baseline;
    margin-bottom: 40px;
  }
  > div {
    width: 100%;
    text-align: left;
    @media screen and (min-width: ${size.medium}px) {
      width: 50%;
    }
    &:first-child {
      border-right: none;
      border-bottom: 1px solid ${color.darkgrey};
      @media screen and (min-width: ${size.medium}px) {
        border-right: 1px solid ${color.darkgrey};
        border-bottom: none;
      }
    }
  }
  @media screen and (min-width: ${size.medium}px) {
    flex-direction: row;
  }
`;

const TopArticleContainer = Container.extend`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column-reverse;

  @media screen and (min-width: ${size.xLarge}px) {
    width: 1020px;
    flex-direction: row;
    padding-left: 120px;
    justify-content: space-between;
  }
  @media screen and (min-width: ${size.articleSideMenuBreakPoint}px) {
    position: relative;
    width: 820px;
    padding-left: 80px !important;
  }
`;

const ArticleHeader = Heading.h1.extend`
  ${dynamicFontSize(40, 60)};
`;

const ArticlePreamble = Preamble.extend`
  ${dynamicFontSize(18, 20, size.small, size.medium)};
  margin-bottom: 1.5em !important;
`;

ArticlePage.defaultProps = {
  currentPage: Map(),
  pageWidth: 1024,
  request: Map()
};

ArticlePage.propTypes = {
  currentPage: PropTypes.instanceOf(Map),
  request: PropTypes.instanceOf(Map),
  fetchArticlePageView: PropTypes.func.isRequired,
  pageWidth: PropTypes.number,
  location: PropTypes.object.isRequired
};

export default connect(ArticlePage, { fetchArticlePageView }, (store, props) => ({
  pageWidth: store.viewstate.get('pageWidth'),
  request: store.page.request.get(props.location.pathname),
  currentPage: store.page.data.get(props.location.pathname)
}));



// WEBPACK FOOTER //
// ./src/pages/ArticlePage.js